import { FormGroup } from '@angular/forms';
export class ValidationService {


    static emailValidator(control) {
        // RFC 2822 compliant regex
        if (control && control.value && control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return null;
        } else {
            return { invalidEmailAddress: true };
        }
    }

    // static validateValue(model, field, operation) {
    //     return function innerFunction(control) {
    //         if (control && control.value && field && operation && model && model[field]) {
    //             switch (operation) {
    //                 case 'less than or equal to':
    //                     if (control.value > model[field])
    //                         return { valueGreaterThanAllowed: true };
    //                     break;
    //                 case 'less than':
    //                     if (control.value >= model[field])
    //                         return { valueGreaterThanOrEqualToAllowed: true };
    //                     break;
    //                 case 'equal to':
    //                     if (control.value !== model[field])
    //                         return { valueNotEqualToAllowed: true };
    //                     break;
    //                 case 'greater than or equal to':
    //                     if (control.value < model[field])
    //                         return { valueLesserThanAllowed: true };
    //                     break;
    //                 case 'greater than':
    //                     if (control.value <= model[field])
    //                         return { valueLesserThanOrEqualToAllowed: true };
    //                     break;
    //                 case 'not equal to':
    //                     if (control.value == model[field])
    //                         return { valueEqualToAllowed: true };
    //                     break;
    //                 default:
    //                     break;
    //             }
    //             return null;
    //         } else {
    //             return null;
    //         }
    //     };
    // }
    // static validateValue(form: FormGroup, field, operation) {
    //     let fieldChanges = false;
    //     if (!form)
    //         return null;
    //     else
    //         return function innerFunction(control) {
    //             if (!fieldChanges) {
    //                 form.controls[field].valueChanges.subscribe(() => { control.updateValueAndValidity(); });
    //                 fieldChanges = true;
    //             }
    //             if (control && control.value) {
    //                 switch (operation) {
    //                     case 'less than or equal to':
    //                         if (control.value > form.controls[field].value)
    //                             return { valueGreaterThanAllowed: true };
    //                         break;
    //                     case 'less than':
    //                         if (control.value >= form.controls[field].value)
    //                             return { valueGreaterThanOrEqualToAllowed: true };
    //                         break;
    //                     case 'equal to':
    //                         if (control.value !== form.controls[field].value)
    //                             return { valueNotEqualToAllowed: true };
    //                         break;
    //                     case 'greater than or equal to':
    //                         if (control.value < form.controls[field].value)
    //                             return { valueLesserThanAllowed: true };
    //                         break;
    //                     case 'greater than':
    //                         if (control.value <= form.controls[field].value)
    //                             return { valueLesserThanOrEqualToAllowed: true };
    //                         break;
    //                     case 'not equal to':
    //                         if (control.value == form.controls[field].value)
    //                             return { valueEqualToAllowed: true };
    //                         break;
    //                     default:
    //                         break;
    //                 }
    //                 return null;
    //             } else {
    //                 return null;
    //             }
    //         };
    // }

    static phoneValidator(control) {
        // RFC 2822 compliant regex
        // if (control && control.value && control.value.match(/^\d{10}$/)) {
        return null;
        // } else {
        //     return { invalidPhoneNumber: true };
        // }
    }

    static geolocationValidator(control) {
        // RFC 2822 compliant regex
        // if (control && control.value && control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
        return null;
        // } else {
        // return { invalidEmailAddress: true };
        // }
    }

    // static getValidatorErrorMessage(code: string) {
    //     let config = {
    //         required: 'Required',
    //         // invalidCreditCard: 'Is invalid credit card number',
    //         invalidEmailAddress: 'Invalid Email Address',
    //         invalidPositiveInteger: 'Invalid Entry'
    //         // invalidPassword: 'Invalid password. Password must be at least 6 characters long, and contain a number.'
    //     };

    //     return config[code];
    // }



    // static creditCardValidator(control) {
    //     // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    //     if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
    //         return null;
    //     } else {
    //         return { invalidCreditCard: true };
    //     }
    // }
    // static confirmPassword(form: FormGroup, field) {
    //   let fieldChanges = false;
    //   return function innerFunction(control) {
    //     if (!fieldChanges) {
    //       form.controls[field].valueChanges
    //         .subscribe(() => {
    //           control.updateValueAndValidity();
    //         });
    //       fieldChanges = true;
    //     }
    //     if (control.value === form.controls[field].value) {
    //       return null;
    //     } else {
    //       return { not_matching: true };
    //     }
    //   };
    // }

    // static passwordValidator(control) {
    //     // {6,100}           - Assert password is between 6 and 100 characters
    //     // (?=.*[0-9])       - Assert a string has at least one number
    //     if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
    //         return null;
    //     } else {
    //         return { invalidPassword: true };
    //     }
    // }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/validation.service.ts